import { useEffect, useState } from "react";
import _ from "lodash";

import HexModal from "../../../../../components/HexModal";
import { placeOrder } from "../../../../../redux/reducers/order/order-action";
import {
  getStorageItem,
  handleError,
  removeLocalStorageItems,
  setStorageItem,
} from "../../../../../utils/common-utils";

import SuccessfulPayment from "../../../../../components/PaymentProcessor/components/SuccessfulPayment";
import FailedPayment from "../../../../../components/PaymentProcessor/components/FailedPayment";
import { getLabel } from "../../../../../hooks/use-labels";
import { updateStorageOnClearCart } from "../../../../SupplierDetail/ProductDetailModal/ProductDetails/product-cart-detail-utils";
import { useNavigate } from "react-router-dom";
import PaymentConfirmationSpinner from "../../../../../components/PaymentConfirmationSpinner";

let timeoutRef;

const OrderModal = ({ transactionIds, onClose, showTimer }) => {
  const [loading, setLoading] = useState(false);
  const [orderDetails, setOrderDetails] = useState({});
  const [error, setError] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const reservation = getStorageItem("reservationInfo");
    const params = {
      transactionIds,
      pendingOrderId: reservation.reservationId,
    };

    setLoading(true);
    placeOrder(params)
      .then(({ data }) => {
        setStorageItem("freePayment", true);

        setOrderDetails(data);
        updateStorageOnClearCart();
        removeLocalStorageItems(["reservationInfo"]);
        setLoading(false);

        timeoutRef = setTimeout(() => moveToOrderDetail(data.id), 10000);
      })
      .catch((error) => {
        const errorMessage = handleError(error);
        setLoading(false);
        showTimer();
        setError(errorMessage);
      });

    return () => {
      if (timeoutRef) {
        clearTimeout(timeoutRef);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const moveToOrderDetail = (id) => {
    navigate(`/my-orders/detail?id=${id}`, {
      state: { link: { path: "/my-orders", previousState: { paramTab: "" } } },
    });
  };

  return (
    <HexModal open={true} modalClass="order-modal">
      {loading && <PaymentConfirmationSpinner />}

      {!loading && !_.isEmpty(orderDetails) && (
        <SuccessfulPayment
          onButtonClick={() => moveToOrderDetail(orderDetails.id)}
          buttonLabel={getLabel("trackOrderLabel")}
          paymentMessage={getLabel("successfulOrderLabel").replace(
            "{{}}",
            orderDetails.id
          )}
        />
      )}

      {!loading && error && <FailedPayment onClick={onClose} />}
    </HexModal>
  );
};

export default OrderModal;
